import { SessionState } from './types'

export const initialSessionState: SessionState = {
	isAdmin: false,
	domain: '',
	url: '',
	driveItemId: '',
	name: '',
	channelId: '',
	qr: '',
	code: '',
	connected: false,
	ended: false,
	fileEditor: '',
	username: '',
	password: '',
	users: [],
	percent: 0,
	status: 'In Queue'
}
